var map = {
	"./Genie.svg": "ef1a",
	"./active_icon.svg": "e9be",
	"./ads.svg": "698d",
	"./affiliate-settings.svg": "8c9c",
	"./billing-cyan.svg": "5d3e",
	"./billing-orange.svg": "0bb2",
	"./chatgenie-logo-beta.svg": "b090",
	"./check-mark.svg": "37e8",
	"./deactivate.svg": "1658",
	"./deactivated.svg": "9b676",
	"./faq.svg": "2c4a",
	"./feature-get-insights.svg": "4439",
	"./feature-online-store.svg": "74c4",
	"./gear.svg": "ca7f",
	"./grace_period.svg": "d0cc",
	"./help-blog.svg": "8bc2",
	"./help-community.svg": "8eea",
	"./help-office.svg": "817f",
	"./help-permission.svg": "4894",
	"./help-support.svg": "a682",
	"./help-youtube.svg": "f865",
	"./icon-booking.svg": "db08",
	"./icon-event-ticketing.svg": "9b78",
	"./icon-inquiry-bundle.svg": "fc2b",
	"./icon-loans.svg": "11c4",
	"./icon-online-store.svg": "25a3",
	"./icon-retail.svg": "b714",
	"./instagram-logo.svg": "cb68",
	"./instagram-overview.svg": "ea36",
	"./launch.svg": "12bf",
	"./launch_icon.svg": "b529",
	"./maintenance.svg": "b48c",
	"./messenger-logo.svg": "2a82",
	"./messenger-overview.svg": "9b67",
	"./messenger-preview-icon.svg": "b466",
	"./mobile-layout-header.svg": "2996",
	"./notification_icon.svg": "ec90",
	"./paymaya-logo.svg": "32f5",
	"./paymaya-overview.svg": "ee8b",
	"./pending-orders.svg": "f14c",
	"./reconnect_icon.svg": "a3ce",
	"./sales-partner-get-started-hero-banner.svg": "040e",
	"./setting.svg": "6fdd",
	"./settings-orange.svg": "6b29",
	"./shopping-bag.svg": "5a90",
	"./store-setup-orange.svg": "97d0",
	"./store-setup.svg": "cb98",
	"./store.svg": "dd3a",
	"./success-launch.svg": "5c2b",
	"./terms-cyan.svg": "1846",
	"./terms-orange.svg": "41cb",
	"./viber-logo.svg": "39c7",
	"./viber-overview.svg": "9117"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";